import { render, staticRenderFns } from "./DomandaQuestionarioAssuntivo.vue?vue&type=template&id=1bd423fc&scoped=true&"
import script from "./DomandaQuestionarioAssuntivo.vue?vue&type=script&lang=js&"
export * from "./DomandaQuestionarioAssuntivo.vue?vue&type=script&lang=js&"
import style0 from "./DomandaQuestionarioAssuntivo.vue?vue&type=style&index=0&id=1bd423fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd423fc",
  null
  
)

export default component.exports
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QOptionGroup,QInput,QSelect,QItem,QItemSection,QIcon,QPopupProxy,QDate,QBtn,QCheckbox,QRadio});qInstall(component, 'directives', {ClosePopup});
